// Validate the team data
export const validateTeamData = (teamInfo: any, platformData: any): boolean => {
  // Check if the team info or platform data is not available
  if (!teamInfo || !platformData) return false;

  // Get the team name and league id from the team info
  const { teamName, leagueId } = teamInfo;

  // Check if the team exists in the platform data
  return platformData.leagues?.some((league: any) => league.teams?.some((team: any) => team.name === teamName && league.league_id === leagueId));
};
